var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreBlackEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.534 40H5.02244C2.25436 40 0 37.7456 0 35V5C0 2.24439 2.25436 0 5.02244 0H130.534C133.299 0 135.556 2.24439 135.556 5V35C135.556 37.7456 133.299 40 130.534 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.534 0.800499C132.855 0.800499 134.756 2.68828 134.756 5V35C134.756 37.3117 132.868 39.1995 130.534 39.1995H5.02244C2.70075 39.1995 0.800499 37.3117 0.800499 35V5C0.800499 2.68828 2.68828 0.800499 5.02244 0.800499C5.02244 0.800499 130.534 0.800499 130.534 0.800499ZM130.534 0H5.02244C2.25436 0 0 2.25436 0 5V35C0 37.7556 2.25436 40 5.02244 40H130.534C133.299 40 135.556 37.7556 135.556 35V5C135.556 2.25436 133.299 0 130.534 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4113 13.2319C70.5061 13.2319 69.743 12.9152 69.1395 12.2917C68.541 11.6858 68.2068 10.8504 68.2218 9.99748C68.2218 9.08726 68.531 8.31669 69.1395 7.70571C69.7405 7.08227 70.5036 6.76556 71.4088 6.76556C72.3041 6.76556 73.0672 7.08227 73.6806 7.70571C74.2891 8.33664 74.5983 9.10721 74.5983 9.99748C74.5883 10.9102 74.2791 11.6808 73.6806 12.2893C73.0796 12.9177 72.3165 13.2319 71.4113 13.2319ZM44.4763 13.2319C43.591 13.2319 42.823 12.9202 42.1945 12.3042C41.5711 11.6908 41.2544 10.9152 41.2544 9.99998C41.2544 9.08477 41.5711 8.30921 42.1945 7.69574C42.8105 7.07978 43.5786 6.76806 44.4763 6.76806C44.9152 6.76806 45.3416 6.85534 45.7506 7.0324C46.1521 7.20447 46.4788 7.43888 46.7207 7.72566L46.7805 7.79798L46.1047 8.46132L46.0349 8.37903C45.6534 7.92517 45.1421 7.70322 44.4663 7.70322C43.8629 7.70322 43.3367 7.91768 42.9028 8.34162C42.4664 8.76806 42.2444 9.32666 42.2444 10.0025C42.2444 10.6783 42.4664 11.2369 42.9028 11.6633C43.3367 12.0873 43.8629 12.3017 44.4663 12.3017C45.1097 12.3017 45.6509 12.0873 46.0723 11.6633C46.3217 11.4139 46.4763 11.0648 46.5312 10.6234H44.3641V9.69075H47.4613L47.4738 9.77554C47.4962 9.93265 47.5187 10.0947 47.5187 10.2444C47.5187 11.1047 47.2593 11.8005 46.7456 12.3142C46.1621 12.9227 45.399 13.2319 44.4763 13.2319ZM80.2891 13.0997H79.334L76.4088 8.41893L76.4337 9.26182V13.0972H75.4786V6.90023H76.5684L76.5983 6.94761L79.3489 11.3566L79.324 10.5162V6.90023H80.2891V13.0997V13.0997ZM64.2343 13.0997H63.2667V7.8329H61.5884V6.90023H65.9101V7.8329H64.2318V13.0997H64.2343ZM60.8004 13.0997H59.8353V6.90023H60.8004V13.0997ZM55.3765 13.0997H54.4114V7.8329H52.7331V6.90023H57.0548V7.8329H55.3765V13.0997ZM52.1222 13.0898H48.4214V6.90023H52.1222V7.8329H49.389V9.53364H51.8553V10.4563H49.389V12.1571H52.1222V13.0898ZM69.8477 11.6509C70.2791 12.0823 70.8028 12.2992 71.4113 12.2992C72.0372 12.2992 72.5485 12.0873 72.9749 11.6509C73.3988 11.2269 73.6133 10.6708 73.6133 9.99998C73.6133 9.32916 73.3988 8.77055 72.9774 8.34911C72.546 7.91768 72.0198 7.70073 71.4138 7.70073C70.7879 7.70073 70.2767 7.9127 69.8527 8.34911C69.4288 8.77305 69.2143 9.32916 69.2143 9.99998C69.2143 10.6708 69.4263 11.2294 69.8477 11.6509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1321 21.7556C65.7755 21.7556 63.8652 23.5436 63.8652 26.01C63.8652 28.4539 65.7879 30.2643 68.1321 30.2643C70.4887 30.2643 72.3989 28.4638 72.3989 26.01C72.3989 23.5436 70.4887 21.7556 68.1321 21.7556ZM68.1321 28.5785C66.8428 28.5785 65.7331 27.5112 65.7331 26C65.7331 24.4663 66.8453 23.4214 68.1321 23.4214C69.4213 23.4214 70.5311 24.4663 70.5311 26C70.5336 27.5212 69.4213 28.5785 68.1321 28.5785ZM58.8228 21.7556C56.4662 21.7556 54.556 23.5436 54.556 26.01C54.556 28.4539 56.4787 30.2643 58.8228 30.2643C61.1794 30.2643 63.0897 28.4638 63.0897 26.01C63.0897 23.5436 61.1769 21.7556 58.8228 21.7556ZM58.8228 28.5785C57.5336 28.5785 56.4238 27.5112 56.4238 26C56.4238 24.4663 57.536 23.4214 58.8228 23.4214C60.1121 23.4214 61.2218 24.4663 61.2218 26C61.2218 27.5212 60.1121 28.5785 58.8228 28.5785ZM47.7455 23.0549V24.8554H52.0672C51.935 25.8653 51.6009 26.611 51.0896 27.1222C50.4562 27.7556 49.4787 28.4439 47.7555 28.4439C45.0996 28.4439 43.0223 26.2992 43.0223 23.6434C43.0223 20.9875 45.0996 18.8429 47.7555 18.8429C49.1894 18.8429 50.2343 19.409 51.0098 20.1322L52.2867 18.8554C51.2094 17.8229 49.7754 17.0324 47.7655 17.0324C44.1221 17.0324 41.0647 20 41.0647 23.6334C41.0647 27.2768 44.1196 30.2344 47.7655 30.2344C49.733 30.2344 51.2094 29.591 52.3764 28.379C53.566 27.1895 53.9425 25.5112 53.9425 24.1571C53.9425 23.7357 53.9101 23.3566 53.8428 23.0349H47.743C47.7455 23.0324 47.7455 23.0549 47.7455 23.0549ZM93.0548 24.4563C92.6982 23.5012 91.6209 21.7456 89.4114 21.7456C87.2219 21.7456 85.4014 23.4688 85.4014 26C85.4014 28.389 87.2019 30.2544 89.6234 30.2544C91.5685 30.2544 92.7007 29.0648 93.167 28.3666L91.7231 27.399C91.2443 28.1097 90.5785 28.5761 89.6333 28.5761C88.6782 28.5761 88.0099 28.1421 87.566 27.2868L93.2543 24.9302C93.2543 24.9327 93.0548 24.4563 93.0548 24.4563ZM87.2543 25.8778C87.2094 24.2344 88.5311 23.399 89.4762 23.399C90.2219 23.399 90.8428 23.7656 91.0548 24.2992L87.2543 25.8778ZM82.6333 30H84.5012V17.5012H82.6333V30ZM79.566 22.7007H79.4987C79.0772 22.1995 78.2767 21.7456 77.2543 21.7456C75.1321 21.7456 73.177 23.6135 73.177 26.0125C73.177 28.4015 75.1221 30.2469 77.2543 30.2469C78.2642 30.2469 79.0772 29.7905 79.4987 29.2793H79.566V29.8903C79.566 31.5137 78.6982 32.389 77.2992 32.389C76.1545 32.389 75.4438 31.5661 75.1545 30.8778L73.5311 31.5561C73.9974 32.6783 75.2418 34.0673 77.2967 34.0673C79.4862 34.0673 81.3416 32.778 81.3416 29.6334V22H79.576V22.7007C79.5785 22.7007 79.566 22.7007 79.566 22.7007ZM77.4214 28.5785C76.1321 28.5785 75.0548 27.5012 75.0548 26.0125C75.0548 24.5112 76.1321 23.4239 77.4214 23.4239C78.6982 23.4239 79.6882 24.5237 79.6882 26.0125C79.7007 27.5012 78.7007 28.5785 77.4214 28.5785ZM101.8 17.5012H97.3341V30H99.2019V25.2668H101.803C103.87 25.2668 105.903 23.7681 105.903 21.389C105.903 19.01 103.878 17.5012 101.8 17.5012ZM101.855 23.5212H99.1994V19.2319H101.855C103.254 19.2319 104.045 20.3865 104.045 21.3765C104.045 22.3566 103.244 23.5212 101.855 23.5212ZM113.389 21.7332C112.032 21.7332 110.633 22.3342 110.055 23.6434L111.711 24.3317C112.067 23.6434 112.721 23.409 113.411 23.409C114.379 23.409 115.357 23.9875 115.379 25.0199V25.1521C115.045 24.9626 114.312 24.6733 113.434 24.6733C111.646 24.6733 109.833 25.6509 109.833 27.4838C109.833 29.1621 111.299 30.2394 112.933 30.2394C114.187 30.2394 114.878 29.6733 115.309 29.0174H115.377V29.985H117.177V25.197C117.177 22.9676 115.521 21.7332 113.389 21.7332ZM113.155 28.5785C112.544 28.5785 111.688 28.2793 111.688 27.5112C111.688 26.5436 112.756 26.177 113.666 26.177C114.489 26.177 114.878 26.3541 115.367 26.5985C115.232 27.7207 114.284 28.5686 113.155 28.5785ZM123.746 22L121.601 27.4214H121.534L119.312 22H117.302L120.636 29.5785L118.736 33.7905H120.681L125.81 22H123.746ZM106.933 30H108.8V17.5012H106.933V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4339 7.53364C10.1446 7.84536 9.97754 8.32167 9.97754 8.94511V31.0573C9.97754 31.6807 10.1446 32.157 10.4439 32.4563L10.5212 32.5236L22.9103 20.1346V19.8578L10.5112 7.46631L10.4339 7.53364Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0323 24.2768L22.9001 20.1447V19.8554L27.0323 15.7232L27.1221 15.7781L32.0098 18.5561C33.4088 19.3442 33.4088 20.6459 32.0098 21.4439L27.1221 24.222L27.0323 24.2768Z",
    fill: "url(#paint1_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1221 24.2219L22.9002 20L10.4338 32.4663C10.8902 32.9551 11.6558 33.01 12.5111 32.5337L27.1221 24.2219Z",
    fill: "url(#paint2_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1221 15.7781L12.5111 7.47882C11.6558 6.99004 10.8877 7.05737 10.4338 7.54615L22.9002 20L27.1221 15.7781Z",
    fill: "url(#paint3_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0324 24.1321L12.5212 32.3766C11.7107 32.8429 10.9875 32.8105 10.5212 32.3865L10.4438 32.4638L10.5212 32.5312C10.9875 32.9526 11.7107 32.9875 12.5212 32.5212L27.1321 24.2219L27.0324 24.1321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.01 21.2993L27.02 24.1322L27.1098 24.2219L31.9976 21.4439C32.6983 21.0449 33.0425 20.5212 33.0425 20C33.0001 20.4788 32.6435 20.9327 32.01 21.2993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5112 7.62342L32.01 18.7008C32.6434 19.0574 33 19.5237 33.0549 20C33.0549 19.4788 32.7108 18.9551 32.01 18.5561L12.5112 7.47878C11.1122 6.67828 9.97754 7.34661 9.97754 8.94512V9.08975C9.97754 7.48875 11.1122 6.83289 12.5112 7.62342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 21.799,
    y1: 8.70654,
    x2: 1.95383,
    y2: 13.9943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 33.8342,
    y1: 20.0001,
    x2: 9.63751,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 24.8264,
    y1: 22.2973,
    x2: 8.89486,
    y2: 49.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 7.29468,
    y1: 0.178805,
    x2: 14.4024,
    y2: 12.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.556,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreBlackEn);
export default __webpack_public_path__ + "static/media/play_store_black_en.46a2b14214e51b7759e70104bf0eb711.svg";
export { ForwardRef as ReactComponent };